import type { OriginalForm, OriginalFormMap } from 'state/secondaryMarket/shared/form/original/original.model';

import type { LiveForm } from '../input/inputForm.model';

export type SecondaryMarketLiveReloadedForm = OriginalForm<LiveForm> &
  Readonly<{
    upfront?: number;
    accruedInterest?: number;
  }>;

export type SecondaryMarketLiveReloadedFormMap = OriginalFormMap<LiveForm, SecondaryMarketLiveReloadedForm>;

export const initialLiveReloadedFormMap: SecondaryMarketLiveReloadedFormMap = {};
export const initialLiveReloadedForm: SecondaryMarketLiveReloadedForm = {
  tradeSizeInputMode: undefined,
  clientType: 'Other',
};
